<template>
  <div class="card-item">
    <div class="title-box">
      <span class="title-text">思政微课基本信息</span>
      <span class="btn-action-group"> </span>
    </div>
    <div class="mt30">
      <div class="form-item">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 思政微课名称
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            placeholder="请输入思政微课名称"
            :maxLength="100"
            v-model="info.name"
            :disabled="isEdit || !isbj"
          />
        </div>
      </div>
      <div class="form-item">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 申报年份
        </div>
        <div class="pl16">
          <a-date-picker
            placeholder="请选择申报年份"
            v-model="info.applyYear"
            :disabled="isEdit || !isbj"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            class="form-item-right"
          />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div class="form-item">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 创建时间
        </div>
        <div class="pl16">
          <a-date-picker
            class="form-item-right"
            placeholder="请选择创建时间"
            v-model="info.foundTime"
            :disabled="isEdit"
            :format="'YYYY-MM-DD'"
            :locale="locale"
          />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div class="form-item" style="width: 100%">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 所属专业
        </div>
        <div
          class="pl16"
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <a-select
            style="width: 32%"
            show-search
            v-model="info.basicMajorCategory"
            option-filter-prop="children"
            :filter-option="filterOption"
            :disabled="isEdit"
            @change="handleChange"
          >
            <a-select-option value="">请选择专业大类</a-select-option>
            <a-select-option v-for="item in zydlList" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-select
            style="width: 32%"
            show-search
            v-model="info.basicMajorSubclass"
            option-filter-prop="children"
            :filter-option="filterOption"
            :disabled="isEdit"
            @change="handleChange1"
          >
            <a-select-option value="">请选择专业子类</a-select-option>
            <a-select-option v-for="item in zyzlList" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-select
            style="width: 32%"
            show-search
            v-model="info.basicMajor"
            option-filter-prop="children"
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option value="">请选择专业</a-select-option>
            <a-select-option v-for="item in zyList" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="mt30">
      <div class="form-item" style="width: 100%">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 所属课程
        </div>
        <div class="pl16">
          <a-select
            mode="tags"
            style="width: 100%"
            class="course-tags-select"
            v-model="info.course"
            :disabled="isEdit"
            placeholder="请选择课程"
          >
            <a-select-option v-for="item in kcList" :value="item.courseName">
              {{ item.courseName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="mt30">
      <div class="form-item">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 课程类型
        </div>
        <div class="pl16">
          <a-select
            style="width: 100%"
            v-model="info.courseType"
            :disabled="isEdit"
            placeholder="请选择课程"
          >
            <a-select-option v-for="item in kclists" :value="item.title">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="form-item">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 学习人次
        </div>
        <div class="pl16">
          <a-input-number
            class="input-style-2"
            type="text"
            placeholder="请输入学习人次"
            v-model="info.wkStudyNum"
            :maxLength="10"
            :disabled="isEdit"
          />
        </div>
      </div>  
    </div>
    <div class="mt30">
      <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 级别
          </div>
          <div class="pl16">
            <a-select
              v-model="info.levelType"
              :disabled="isEdit"
              style="width: 100%"
              placeholder="请选择级别"
            >
              <a-select-option
                :value="item.text"
                v-for="item in jblist"
                :key="item.text"
                >{{ item.title }}</a-select-option
              >
            </a-select>
          </div>
        </div>
    </div>
    <div class="mt30">
      <div class="form-item-upload">
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>
          申报书上传
        </div>
        <div class="pl16">
          <!--  -->
          <a-upload
            :file-list="fileList"
            disabled="disabled"
            :remove="(file, fileList) => handleRemove(file, fileList)"
            :before-upload="(file, fileList) => beforeUpload(file, fileList)"
            accept=".pdf"
          >
            <a-button :disabled="isEdit || loading" :loading="loading">
              <a-icon type="upload" />上传附件
            </a-button>
            <span class="text2">注：请上传pdf格式的文件</span>
          </a-upload>
        </div>
      </div>
    </div>
    <!-- <template v-if="!isEdit || !isbj">
        <div class="submit-btn-box">
          <div class="btn-group">
            <a-button type="primary" class="btn-action"  @click="goStep">保存</a-button>
           
          </div>
        </div>
    </template> -->
    <!-- <a-button class="btn-action" @click="onClean">取消</a-button> -->
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { baseURL } from "@/utils/request.js";
import {
  getAction,
  postAction,
  putAction,
  deleteAction,
  fileUpdate,
} from "@/api/index";
export default {
  name: "",
  components: {},
  props: {
    oldInfos: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
    },
    isbj: {
      type: Boolean,
    },
  },
  data() {
    return {
      isEdit: false,
      info: {
        name: "",
        foundTime: "",
        basicMajorCategory: "",
        basicMajorSubclass: "",
        basicMajor: "",
        course: [],
        id: "",
        applyType: "3",
        applyYear: "",
        courseType: "",
        declarationName: "",
        declarationPath: "",
        wkStudyNum: "",
        levelType: "",
      },
      path: baseURL,
      zh_CN,
      locale,
      zydlList: [],
      zyzlList: [],
      zyList: [],
      kcList: [],
      kclists: [],
      jblist: [],
      yearShowOne: false,
      fileList: [],
      loading: false,
      ispre: false,
      oldInfo: {},
      first: true,
      _applyingOldInfos: false,
    };
  },
  computed: {},
  watch: {
    oldInfos: {
      handler(newValue) {
        if (newValue != null) {
          this.applyOldInfosToForm(newValue);
        }
      },
      deep: true,
    },
    isbj: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = newValue;
      },
      immediate: true,
    },
  },
  created() {
    // if (this.isAdd) {
    //   this.isEdit = true;
    //   return;
    // }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
  },
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    // let oldInfo = JSON.parse(
    //   sessionStorage.getItem(`step${this.$store.state.user.id}`)
    // );
    this.zydl();
    this.getkclist();
    this.getkclists();
    this.getcgjb();
    // if (oldInfo) {
    // 	this.oldInfo=oldInfo;
    //   this.info.type=oldInfo.type;
    //   this.info.auditState=oldInfo.auditState;
    //   this.info.id= oldInfo.id;
    //   this.info.name = oldInfo.name;
    //   this.info.foundTime = oldInfo.foundTime;
    //   this.info.basicMajorCategory = oldInfo.basicMajorCategory;
    //   this.info.basicMajorSubclass=oldInfo.basicMajorSubclass;
    //   this.info.basicMajor=oldInfo.basicMajor;
    //   this.info.wkStudyNum=oldInfo.wkStudyNum;
    //   this.info.courseType=oldInfo.courseType;
    //   this.info.applyYear=oldInfo.applyYear;
    //   this.info.declarationName=oldInfo.declarationName;
    //   this.info.declarationPath=oldInfo.declarationPath;
    //    if(oldInfo.basicMajorCategory!=null && oldInfo.basicMajorCategory!=''){
    // 	    	 this.zyzl(oldInfo.basicMajorCategory);
    // 	    }
    // 	    if(oldInfo.basicMajorSubclass!=null && oldInfo.basicMajorSubclass!=''){
    // 	    	  this.zylist(oldInfo.basicMajorSubclass);
    // 	    }
    //   if(oldInfo.course!=''){
    //   	let course=oldInfo.course;
    //   	let that=this;
    //   	if(course.indexOf(",")>-1){
    //   		setTimeout(function(){
    //   		 that.info.course=course.split(',');
    //   		},10);
    //   	}else if(course.length>0){
    //   		that.info.course=course;
    //   	}else{
    //   		 let arr=[];
    //   		 arr.push(course);
    //   		 setTimeout(function(){
    //   		 that.info.course=arr;
    //   		 },10);
    //   	}

    //   }
    // }
    this.fileList = [];
    // if(oldInfo && oldInfo.declarationName!='' && oldInfo.declarationName!=null && oldInfo.declarationPath!='' && oldInfo.declarationPath!=null){
    // 	 let fileItem = {};
    //       fileItem.path = oldInfo.declarationPath;
    //       fileItem.name = oldInfo.declarationName;
    //        fileItem.uid=1;
    // 	  this.fileList.push(fileItem);
    // }
    if (this.oldInfos) {
      this.info.name = this.oldInfos.name;
      this.info.foundTime = this.oldInfos.foundTime;
      this.info.wkStudyNum = this.oldInfos.wkStudyNum;
      this.info.applyYear = this.toYearMoment(this.oldInfos.applyYear);
      this.info.courseType = this.oldInfos.courseType;
      this.info.levelType = this.oldInfos.levelType || "";
      this.applyOldInfosToForm(this.oldInfos);
    }
    this.$forceUpdate();
  },
  methods: {
    normalizeCourseList(course) {
      if (course == null || course === "") return [];
      let list = [];
      if (Array.isArray(course)) {
        list = course.map((c) => (c == null ? "" : String(c).trim()));
      } else {
        const s = String(course).trim();
        if (!s) return [];
        list = s.indexOf(",") > -1 ? s.split(",") : [s];
        list = list.map((x) => String(x).trim());
      }
      return list.filter(Boolean).slice(0, 50);
    },
    isSameCourseList(a, b) {
      const aa = Array.isArray(a) ? a : this.normalizeCourseList(a);
      const bb = Array.isArray(b) ? b : this.normalizeCourseList(b);
      if (aa.length !== bb.length) return false;
      return aa.every((v, i) => v === bb[i]);
    },
    applyOldInfosToForm(src) {
      if (!src || this._applyingOldInfos) return;
      this._applyingOldInfos = true;
      try {
        if (
          src.declarationName != "" &&
          src.declarationName != null &&
          src.declarationPath != "" &&
          src.declarationPath != null
        ) {
          const sameFile =
            this.fileList.length === 1 &&
            this.fileList[0].path === src.declarationPath &&
            this.fileList[0].name === src.declarationName;
          if (!sameFile) {
            this.fileList = [
              {
                path: src.declarationPath,
                name: src.declarationName,
                uid: 1,
              },
            ];
          }
          if (src.basicMajorCategory != "null" && src.basicMajorCategory != "") {
            this.zyzl(src.basicMajorCategory);
          }
          if (src.basicMajorSubclass != "null" && src.basicMajorSubclass != "") {
            this.zylist(src.basicMajorSubclass);
          }
          this.info.basicMajorSubclass = src.basicMajorSubclass;
          this.info.basicMajor = src.basicMajor;
        }
        const nextCourse = this.normalizeCourseList(src.course);
        if (!this.isSameCourseList(this.info.course, nextCourse)) {
          this.info.course = nextCourse;
        }
        if (this.$parent.editInfo && this.$parent.editInfo.type == "preview") {
          this.isEdit = true;
        }
      } finally {
        this.$nextTick(() => {
          this._applyingOldInfos = false;
        });
      }
    },
    getkclists() {
      getAction("/baseCommon/getDictItemsByCode?code=course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclists = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    toYearMoment(value) {
      if (value === null || value === undefined || value === "") return "";
      if (moment.isMoment(value)) {
        return value.isValid() ? value : "";
      }
      const s = String(value).trim();
      if (/^\d{4}$/.test(s)) {
        return moment(s, "YYYY");
      }
      const m = moment(value);
      return m.isValid() ? moment(String(m.year()), "YYYY") : "";
    },
    normalizeApplyYear() {
      if (!this.info) return;
      this.info.applyYear = this.toYearMoment(this.info.applyYear);
    },
    openChangeOne(status) {
      if (status) {
        this.normalizeApplyYear();
        this.$nextTick(() => {
          this.yearShowOne = true;
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("申报书只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    // 得到年份选择器的值
    panelChangeOne(value) {
      if (!value) {
        this.info.applyYear = "";
      } else if (moment.isMoment(value)) {
        this.info.applyYear = String(value.year());
      } else {
        const m = moment(value);
        this.info.applyYear = m.isValid() ? String(m.year()) : "";
      }
      this.yearShowOne = false;
    },
    zydl() {
      getAction("/infrastructure/basicMajorCategory/allList", {}).then(
        (res) => {
          console.log(res);
          if (res.code === 200) {
            let data = res.result;
            if (data) {
              this.zydlList = data;
            }
          }
        }
      );
    },
    handleChange(value) {
      this.zyzl(value);
      this.info.basicMajorSubclass = "";
      this.info.basicMajor = "";
      this.zyList = [];
    },
    handleChange1(value) {
      this.zylist(value);
      this.info.basicMajor = "";
    },
    zyzl(id) {
      getAction("/infrastructure/basicMajorSubclass/queryByCategoryId", {
        gategoryId: id,
      }).then((res) => {
        //			console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyzlList = data;
          }
        }
      });
    },
    zylist(id) {
      getAction("/infrastructure/basicMajor/queryBySubclassId", {
        subclassId: id,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyList = data;
          }
        }
      });
    },
    getkclist() {
      getAction("/lxBase/lxWkCourse/list", {}).then((res) => {
        console.log(res);
        if (res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.kcList = data;
          }
        }
      });
    },
    goStep() {
      if (this.info && this.info.name === "") {
        if (this.info.name === "" || this.info.name == undefined) {
          this.$message.info("请填写思政微课名称");
          return false;
        }
      } else if (
        (this.info && this.info.applyYear === "") ||
        this.info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      } else if (this.info && this.info.foundTime === "") {
        if (this.info.foundTime === "" || this.info.foundTime == undefined) {
          this.$message.info("请选择创建时间");
          return false;
        }
      }

      if (this.info && this.info.basicMajorCategory === "") {
        if (
          this.info.basicMajorCategory === "" ||
          this.info.basicMajorCategory == undefined
        ) {
          this.$message.info("请选择专业大类");
          return false;
        }
      }
      if (this.info && this.info.basicMajorSubclass === "") {
        if (
          this.info.basicMajorSubclass === "" ||
          this.info.basicMajorSubclass == undefined
        ) {
          this.$message.info("请选择专业子类");
          return false;
        }
      }

      if (this.info && this.info.basicMajor === "") {
        if (this.info.basicMajor === "" || this.info.basicMajor == undefined) {
          this.$message.info("请选择专业");
          return false;
        }
      }
      console.log(this.info.course);
      if (this.info && this.info.course.length == "0") {
        if (this.info.course.length == "0" || this.info.course == undefined) {
          this.$message.info("请选择课程");
          return false;
        }
      }
      if (
        (this.info && this.info.courseType === "") ||
        this.info.courseType == undefined
      ) {
        this.$message.info("请选择课程类型");
        return false;
      }

      if (
        (this.info && this.info.wkStudyNum === "") ||
        this.info.wkStudyNum == undefined
      ) {
        this.$message.info("请输入学习人次");
        return false;
      }
      if (
        (this.info && this.info.levelType === "") ||
        this.info.levelType == undefined
      ) {
        this.$message.info("请选择级别");
        return false;
      }
      if (this.fileList.length == 0) {
        this.$message.info("请上传申报书");
        return false;
      }
      const dateObj = new Date(this.info.foundTime);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
      const date = dateObj.getDate();
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;
      let course = this.info.course;
      if (Array.isArray(course)) {
        course = course.join(",");
      }
      //				console.log(course,"4567");
      let params = {
        applyType: this.info.applyType,
        name: this.info.name,
        basicMajorCategory: this.info.basicMajorCategory,
        foundTime: formattedDate,
        basicMajor: this.info.basicMajor,
        basicMajorSubclass: this.info.basicMajorSubclass,
        course: course,
        courseType: this.info.courseType,
        applyYear: new Date(this.info.applyYear).getFullYear() + "",
        id: this.info.id,
        declarationName: this.fileList[0].name,
        declarationPath: this.fileList[0].path,
        wkStudyNum: this.info.wkStudyNum,
        levelType: this.info.levelType,
      };
      this.info.declarationName = this.fileList[0].name;
      this.info.declarationPath = this.fileList[0].path;
      postAction("/lx/lxApply/wkAdd", params).then((res) => {
        if (res.code == 200) {
          this.info.id = res.result.id;
          this.info.hasResource = res.result.hasResource;
          this.$message.success("保存成功");
          // this.info.type=this.$parent.editInfo.type;
          window.sessionStorage.setItem(
            `step${this.$store.state.user.id}`,
            JSON.stringify(this.info)
          );
          this.$emit("goStep", this.info);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card-item {
  background: #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  padding: 37px 20px;
  box-sizing: border-box;
  margin-bottom: 24px;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;
    .title-text {
      color: #2155b5;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.mt30 {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    display: flex;
    align-items: center;
    width: 50%;
    margin-bottom: 10px;
    .main-text-style {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #121212;
      margin-bottom: 0px;
      width: 165px;
      flex-shrink: 0;
       text-align: right;
          padding-right: 10px;
          box-sizing: border-box;
    }
    .pl16 {
      width: calc(100%- 235px);
    }
    .form-item-right {
      width: 100%;
    }
    // .form-item-right {
    //   width: 240px;
    // }
  }
  .form-item-upload {
    display: flex;
    align-items: center;
    .main-text-style {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 0px;
      width: 165px;
      flex-shrink: 0;
       text-align: right;
          padding-right: 10px;
          box-sizing: border-box;
    }
    .form-item-right {
      width: 240px;
    }
  }
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    margin-top: 50px;
    .btn-action {
      width: 116px;
      height: 40px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      line-height: 38px;
      text-align: center;
    }
  }
}

.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
// /deep/ .ant-calendar-picker {
//   width: 50%;
// }
/deep/ .ant-select-selection--single {
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
/deep/ .ant-select-selection__rendered,
/deep/ .ant-select-selection--multiple .ant-select-selection__placeholder {
  margin-left: 0px;
}
/* 所属课程：放得下单行，放不下自动换行（用 float，避免 flex+max-width:100% 变成一行一个） */
.course-tags-select {
  /deep/ .ant-select-selection--multiple {
    min-height: 54px !important;
    height: auto !important;
    padding: 4px 11px !important;
    font-size: 18px !important;
    border: 1px solid #d9d9d9;
    color: #999999;
    overflow: hidden;
  }
  /deep/ .ant-select-selection__rendered {
    display: block !important;
    height: auto !important;
    min-height: 44px;
    line-height: 32px !important;
    margin-left: 0 !important;
    margin-bottom: 0 !important;
    padding: 0 !important;
  }
  /deep/ .ant-select-selection__choice {
    float: left !important;
    flex: none !important;
    width: auto !important;
    max-width: 99% !important;
    height: 28px !important;
    line-height: 26px !important;
    margin: 10px 4px 3px 0 !important;
    padding: 0 20px 0 8px !important;
    box-sizing: border-box;
    overflow: hidden;
  }
  /deep/ .ant-select-selection__choice__content {
    display: inline-block !important;
    max-width: none !important;
    white-space: nowrap !important;
    word-break: normal !important;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 26px !important;
  }
  /deep/ .ant-select-search--inline {
    float: left !important;
    flex: none !important;
    width: auto !important;
  }
  /deep/ .ant-select-selection__placeholder {
    top: 50% !important;
    transform: translateY(-50%) !important;
    margin-top: 0 !important;
    line-height: 1.2 !important;
  }
}
/deep/ .ant-input {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin: 20px;
  width: 165px;
}
.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155b5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
</style>
